var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSuninline = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  overflow: "visible",
  viewBox: "0 0 8 8"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeWidth: 0.5,
  d: "M3.99137 1.33333L3.98705 0M6.66667 3.99137L8 3.98705M4.00863 6.66667L4.01295 8M1.33333 4.00863L0 4.01295M5.87955 2.10831L6.8193 1.16245M5.89176 5.87955L6.83762 6.8193M2.12052 5.89176L1.18076 6.83762M2.10831 2.12052L1.16245 1.18076M6 3.99352C6.00358 5.09809 5.11104 5.99642 4.00648 6C2.90191 6.00358 2.00358 5.11105 2 4.00648C1.99642 2.90191 2.88895 2.00358 3.99352 2C5.09809 1.99642 5.99642 2.88895 6 3.99352Z"
})));
export default SvgSuninline;